import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
// import { OneSignal } from '@ionic-native/onesignal/ngx';
import OneSignal from 'onesignal-cordova-plugin';
import { Platform } from '@ionic/angular';
import { Storage } from '@ionic/storage';

@Injectable({
  providedIn: 'root'
})
export class PushService {
  playerId: string
  userId: string

  constructor(
    // private oneSignal: OneSignal,
    private platform: Platform,
    private router: Router,
    private storage: Storage
  ) {}

  initConfig() {
    this.platform.ready().then(() => {
      this.OneSignalInit()
    })

    // this.oneSignal.startInit('d850da5e-7146-4491-b288-4ebc000e1ef2', '867701997993')

    // this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.InAppAlert)

    // this.oneSignal.handleNotificationReceived().subscribe((noti) => {
    //   // do something when notification is received
    //   console.log('notificación recibida', noti)
    // })

    // this.oneSignal.handleNotificationOpened().subscribe(async (noti) => {
    //   // do something when a notification is opened
    //   console.log('notificación abierta', noti)
    //   this.router.navigateByUrl('/request-history')
    // })

    // this.oneSignal.getIds().then((info) => {
    //   this.userID = info.userId
    //   console.log('userID---------- ', this.userID)
    //   this.storage.set('playerID', this.userID)
    // })

    // this.oneSignal.endInit()
  }

  // Call this function when your app starts
  OneSignalInit() {
    const router = this.router
    OneSignal.setAppId("d850da5e-7146-4491-b288-4ebc000e1ef2");
    OneSignal.setNotificationOpenedHandler(function(jsonData) {
    console.log('sampleId:', jsonData.notification.additionalData["sampleId"]);
    if(jsonData.notification.additionalData["sampleId"])
      router.navigate(["request-history/get_sample/" + jsonData.notification.additionalData["sampleId"]]);
    else
      router.navigate(["request-history"]);
    });

    // Prompts the user for notification permissions.
    //    * Since this shows a generic native prompt, we recommend instead using an In-App Message to prompt for notification permission (See step 7) to better communicate to your users what notifications they will get.
    OneSignal.promptForPushNotificationsWithUserResponse(function(accepted) {
        console.log("User accepted notifications: " + accepted);
    });
    OneSignal.getDeviceState((response) => {
      console.log("userId", response.userId);
      this.userId = response.userId;
    });

  }
}
